<template>
	<div class="personCont">
      
      <div v-if="showdata==1">
        <div class="title f-20 cf">
          <div class="fl cf">
          	<div class="srNavItem on">我的供需</div>
          	<div class="srNavItem" @click="sendTabMenu('recruit')">我的招聘</div>
          </div>
          <div class="fr cf f-14">
            <div class="supplySearch cf fl">
              <input type="text" v-model="keyword" name="keyword" placeholder="请输入内容" @keyup.enter="searchFun">
              <button @click="searchFun" type="button">&nbsp;</button>
            </div>

            <div class="supplyPubBtn fl" @click="pubSupply">发布新供需</div>
          </div>
        </div>
        
        <div class="supplyTable manyItem" v-if="noMessage==false">
          <table>
            <tr>
              <th>标题</th>
              <th>公司名称</th>
              <th>预算金额</th>
              <th>联系人</th>
              <th>联系电话</th>
              <th>状态</th>
              <th>审核状态</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item,index) in list">
              <td>{{item.title}}</td>
              <td>{{item.titleTwo}}</td>
              <td>￥{{item.titleThree}}</td>
              <td>{{item.titleFour}}</td>
              <td>{{item.titleFive}}</td>

              <!-- <td v-if="item.status==1">已发布</td>
              <td v-else>未发布</td> -->
              <td v-if="item.subTitle=='closed'">已成交</td>
              <td v-else-if="item.subTitle=='ongoing'">进行中</td>
              <td v-else-if="item.status==1">已发布</td>
              <td v-else>未发布</td>
              

              <td v-if="item.status==1">审核成功</td>
              <td v-else-if="item.status==6">未通过</td>
              <td v-else>待审核</td>

              <td>
                <span class="btn" @click="toSee(item.id)">查看</span>
                <span class="btn" v-if="item.status!=1" @click="toEdit(item.id)">编辑</span>
                <span class="btn" v-if="item.status==0" @click="toPublish(item.id)">发布</span>
                <span class="btn" v-if="item.status==1" @click="unPublish(item.id)">下架</span>
              </td>
            </tr>
          </table>
        </div>
        
        <div class="mt80" v-if="noMessage==false">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentpage"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalnum">
          </el-pagination>
        </div>

        <div style="text-align:center;padding-top:50px;" v-if="noMessage==true">暂无内容</div>
      </div>

      <div v-if="showdata==2">
        <div class="title f-20 cf">发布供需<span @click="showdata=1" class="back f-16">返回</span></div>

        <div class="personResetForm">
          <div class="item cf">
            <div class="name fl">选择发布类型<span>*</span></div>
            <div class="ovh">
              <el-radio-group v-model="radio">
                <el-radio label="supply">供给</el-radio>
                <el-radio label="demand">需求</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="item cf">
            <div class="name fl">标&emsp;&emsp;题<span>*</span></div>
            <div class="txt ovh"><input type="text" v-model="title" name="title" placeholder="请输入标题"></div>
          </div>
          <div class="item cf">
            <div class="name fl">分&emsp;&emsp;类<span>*</span></div>
            <div class="txt ovh">
              <el-cascader
                v-model="classify"
                :options="cOptions"
                :props="{expandTrigger:'hover',value:'typeCode',label:'title',children:'sub'}">
              </el-cascader>
            </div>
          </div>
          <div class="item cf">
            <div class="name fl">行&emsp;&emsp;业<span>*</span></div>
            <div class="txt ovh">
              <el-cascader
                v-model="industry"
                :options="iOptions"
                :props="{expandTrigger:'hover',value:'typeCode',label:'title',children:'sub'}">
              </el-cascader>
            </div>
          </div>
          <div class="item cf">
            <div class="name fl">领&emsp;&emsp;域&nbsp;&nbsp;</div>
            <div class="txt ovh">
              <el-cascader
                v-model="area"
                :options="aOptions"
                :props="{expandTrigger:'hover',value:'typeCode',label:'title',children:'sub'}">
              </el-cascader>
            </div>
          </div>
          <div class="item cf">
            <div class="name fl">简&emsp;&emsp;介<span>*</span></div>
            <div class="txt ovh"><textarea v-model="intro" placeholder="简介"></textarea></div>
          </div>

          <div class="item cf">
            <div class="name fl">公司名称<span>*</span></div>
            <div class="txt ovh"><input type="text" v-model="company" name="company" placeholder="请输入公司名称"></div>
          </div>
          
          <div class="item cf">
            <div class="name fl">供需详情<span>*</span></div>
            <div class="txt ovh"><textarea v-model="info" placeholder="供需详情"></textarea></div>
          </div>
          
          <div class="item cf">
            <div class="name fl">预算金额<span>*</span></div>
            <div class="txt ovh"><input type="text" v-model="price" name="price" placeholder="请输入预算金额"></div>
          </div>

          <div class="item cf">
            <div class="name fl">联&nbsp;系&nbsp;人<span>*</span></div>
            <div class="txt ovh"><input type="text" v-model="person" name="person" placeholder="请输入联系人"></div>
          </div>

          <div class="item cf">
            <div class="name fl">联系电话<span>*</span></div>
            <div class="txt ovh"><input type="text" v-model="tel" name="tel" placeholder="请输入联系电话"></div>
          </div>

          <div class="item cf">
            <div class="name fl">&emsp;</div>
            <div class="ovh"><div class="sub f-16" @click="subSupplyFun">提交</div></div>
          </div>
        </div>
      </div>

      <div v-if="showdata==3">
        <div class="title f-20 cf">发布供需 <span @click="showdata=1" class="back f-16">返回</span></div>

        <div class="personResetForm">
          <div class="item cf">
            <div class="name fl">选择发布类型:</div>
            <div class="ovh" v-if="radio=='supply'">供给</div>
            <div class="ovh" v-if="radio=='demand'">需求</div>
          </div>
          <div class="item cf">
            <div class="name fl">标&emsp;&emsp;题<span>*</span></div>
            <div class="ovh">{{title}}</div>
          </div>
          <div class="item cf">
            <div class="name fl">分&emsp;&emsp;类<span>*</span></div>
            <div class="ovh">{{classifyStr}}</div>
          </div>
          <div class="item cf">
            <div class="name fl">行&emsp;&emsp;业<span>*</span></div>
            <div class="ovh">{{industryStr}}</div>
          </div>
          <div class="item cf">
            <div class="name fl">领&emsp;&emsp;域&nbsp;&nbsp;</div>
            <div class="ovh">{{areaStr}}</div>
          </div>
          <div class="item cf">
            <div class="name fl">简&emsp;&emsp;介<span>*</span></div>
            <div class="ovh">{{intro}}</div>
          </div>

          <div class="item cf">
            <div class="name fl">公司名称<span>*</span></div>
            <div class="ovh">{{company}}</div>
          </div>
          
          <div class="item cf">
            <div class="name fl">供需详情<span>*</span></div>
            <div class="ovh">{{info}}</div>
          </div>
          
          <div class="item cf">
            <div class="name fl">预算金额<span>*</span></div>
            <div class="ovh">{{price}}</div>
          </div>

          <div class="item cf">
            <div class="name fl">联&nbsp;系&nbsp;人<span>*</span></div>
            <div class="ovh">{{person}}</div>
          </div>

          <div class="item cf">
            <div class="name fl">联系电话<span>*</span></div>
            <div class="ovh">{{tel}}</div>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
import { supplyDemandList , supplyDemandQuery , supplyUpdatePublic , supplyDemandEdit , supplyDemandAdd , queryCategoryByCode } from "@/api/person/person";
import layer from "layui-layer";
export default {
	name: 'supply',
	data(){
		return{
			showdata:true,

	        totalnum:1,
	        pagesize:10,
	        currentpage:1,
	        list:[],

	        radio:'supply',
	        title:'',
	        classify:"",
	        classifyStr:"",
	        industry:"",
	        industryStr:"",
	        area:"",
	        areaStr:"",
	        intro:"",
	        company:"",
	        info:"",
	        price:"",
	        person:"",
	        tel:"",

	        isEdit:true,

	        keyword:'',
	        noMessage:false,

	        cOptions:[],
	        iOptions:[],
	        aOptions:[],

	        editId:''
		}
	},
	mounted(){
		 let that=this
	    that.initSelectData()
	    that.supplyDemandListFun()
	},
	activated(){
		
	},
	computed:{
		
	},
	methods: {
		supplyDemandListFun(){
	      let that=this
	      let datas="title="+that.keyword+"&pageNo="+that.currentpage+"&pageSize="+that.pagesize
	      supplyDemandList(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	          if (res.result!=null&&res.result.records.length>0) {
	            that.list=res.result.records
	            that.totalnum=res.result.total
	          }else{

	          }
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    initSelectData(){
	      let that=this
	      //供需分类supplyDemandType
	      // queryCategoryByCode('typeCode=supplyDemandType').then(res=>{
	      //   console.log(res)
	      //   if(res.success){
	      //   }else{
	      //     that.$message.error(res.message)
	      //     return false
	      //   }
	      // })
	      //需求分类
	      queryCategoryByCode('typeCode=needType').then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.getTypeList(res.result)
	          that.cOptions=res.result
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	      //行业分类
	      queryCategoryByCode('typeCode=industry').then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.getTypeList(res.result)
	          that.iOptions=res.result
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	      //领域
	      queryCategoryByCode('typeCode=areaType').then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.getTypeList(res.result)
	          that.aOptions=res.result
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    //处理没有子项的数据
	    getTypeList(listData) {
	       listData.forEach((items) => {
	          if (items.sub.length > 0) {
	            this.getTypeList(items.sub)
	          } else {
	            items.sub = undefined
	          }
	       })
	    },

	    searchFun(){
	      let that=this
	      // if (that.keyword=='') {
	      //   that.$message.error('请输入搜索关键字')
	      //   return false
	      // }

	      that.currentpage=1
	      that.supplyDemandListFun()
	    },

	    handleSizeChange(val){
	      let that=this
	      that.pagesize=val
	      //console.log(`每页 ${val} 条`);
	      that.supplyDemandListFun()
	    },
	    handleCurrentChange(val){
	      let that=this
	      that.currentpage=val
	      //console.log(`当前页: ${val}`);
	      that.supplyDemandListFun()
	    },

	    pubSupply(){
	      let that=this    

	      that.radio='supply',
	      that.title='',
	      that.classify="",
	      that.classifyStr="",
	      that.industry="",
	      that.industryStr="",
	      that.area="",
	      that.areaStr="",
	      that.intro="",
	      that.company="",
	      that.info="",
	      that.price="",
	      that.person="",
	      that.tel="",

	      that.showdata=2
	      that.isEdit=false
	    },

	    //发布
	    toPublish(id){
	      let that=this  
	      let datas="id="+id+"&status=1"
	      supplyUpdatePublic(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.supplyDemandListFun()
	          that.$message.success("发布成功")
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },
	    //下架
	    unPublish(id){
	      let that=this  
	      let datas="id="+id+"&status=0"
	      supplyUpdatePublic(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.supplyDemandListFun()
	          that.$message.success("撤销成功")
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    toEdit(id){
	      let that=this      
	      that.showdata=2
	      that.isEdit=true

	      that.infoFun(id)
	      that.editId=id
	    },

	    toSee(id){
	      let that=this      
	      that.showdata=3

	      that.infoFun(id)
	    },

	    //详情
	    infoFun(id){
	      let that=this
	      let datas="id="+id
	      supplyDemandQuery(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.title=res.result.title
	          that.radio=res.result.tags
	          that.intro=res.result.intro
	          that.company=res.result.titleTwo
	          that.info=res.result.introTwo
	          that.price=res.result.titleThree
	          that.person=res.result.titleFour
	          that.tel=res.result.titleFive

	          that.classify=that.searchIdFun(that.cOptions,res.result.type)
	          let classifyStr=that.searchTitFun(that.cOptions,res.result.type)
	          that.classifyStr=classifyStr.join("/")

	          that.industry=that.searchIdFun(that.iOptions,res.result.typeTwo)
	          let industryStr=that.searchTitFun(that.iOptions,res.result.typeTwo)
	          that.industryStr=industryStr.join("/")

	          that.area=that.searchIdFun(that.aOptions,res.result.typeThree)
	          let areaStr=that.searchTitFun(that.aOptions,res.result.typeThree)
	          that.areaStr=areaStr.join("/")

	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    //编辑添加提交
	    subSupplyFun(){
	      let that=this
	      if (that.title==''||that.title==null) {
	        that.$message.error("请填写标题")
	        return false
	      }
	      if (that.classify==''||that.classify==null) {
	        that.$message.error("请选择分类")
	        return false
	      }
	      if (that.industry==''||that.industry==null) {
	        that.$message.error("请选择行业")
	        return false
	      }
	      if (that.intro==''||that.intro==null) {
	        that.$message.error("请填写简介")
	        return false
	      }
	      if (that.company==''||that.company==null) {
	        that.$message.error("请填写公司名称")
	        return false
	      }
	      if (that.info==''||that.info==null) {
	        that.$message.error("请填写供需详情")
	        return false
	      }
	      if (that.price==''||that.price==null) {
	        that.$message.error("请填写预算金额")
	        return false
	      }
	      if (that.person==''||that.person==null) {
	        that.$message.error("请填写联系人名称")
	        return false
	      }
	      if (that.tel==''||that.tel==null) {
	        that.$message.error("请填写联系电话")
	        return false
	      }
	      let regTel = new RegExp("^1\\d{10}$");
	      if (!regTel.test(that.tel)) {
	        that.$message.error("手机号格式错误")
	        return false
	      }

	      let datas={
	        title:that.title,
	        tags:that.radio,
	        intro:that.intro,
	        titleTwo:that.company,
	        introTwo:that.info,
	        titleThree:that.price,
	        titleFour:that.person,
	        titleFive:that.tel
	      }

	      let cLen=that.classify.length-1
	      datas.type=that.classify[cLen]

	      let iLen=that.industry.length-1
	      datas.typeTwo=that.industry[iLen]

	      let aLen=that.area.length-1
	      datas.typeThree=that.area[aLen]

	      // console.log(datas)
	      // return
	      if (that.isEdit) {
	        datas.id=that.editId
	        //编辑
	        supplyDemandEdit(datas).then(res=>{
	          if(res.success){
	            that.$message.success(res.result)
	            //window.location.reload()
	            that.showdata=1
	            that.supplyDemandListFun()
	          }else{
	            that.$message.error(res.message)
	            return false
	          }
	        })
	      }else{
	        //添加
	        supplyDemandAdd(datas).then(res=>{
	          if(res.success){
	            that.$message.success(res.result)
	            //window.location.reload()
	            that.showdata=1
	            that.currentpage=1
	            that.supplyDemandListFun()
	          }else{
	            that.$message.error(res.message)
	            return false
	          }
	        })
	      }
	    },

	    //查找id路径用于反显
	    searchIdFun(object, value) {
	      for (var key in object) {
	          if (object[key].typeCode == value) return [object[key].typeCode];
	          if(object[key].sub && Object.keys(object[key].sub).length > 0){
	              var temp = this.searchIdFun(object[key].sub, value);
	              if (temp) return [object[key].typeCode, temp].flat();
	          }
	      }
	    },

	    //查找title用于展示
	    searchTitFun(object, value) {
	      for (var key in object) {
	          if (object[key].typeCode == value) return [object[key].title];
	          if(object[key].sub && Object.keys(object[key].sub).length > 0){
	              var temp = this.searchTitFun(object[key].sub, value);
	              if (temp) return [object[key].title, temp].flat();
	          }
	      }
	    },

	    //切换供需和招聘
	    sendTabMenu(val){
	    	this.$emit('tabMenu', val);
	    }
   	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/supply/index.vue